import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import { AuthenticationService } from './authentication.service';
import { UserInfoDto } from 'api/models';

export const UserInfoResolverService: ResolveFn<UserInfoDto> = (
  _route: ActivatedRouteSnapshot
) => {
  const authService: AuthenticationService = inject(AuthenticationService);
  const router: Router = inject(Router);

  return authService
    .getUserInfo()
    .toPromise()
    .then(userInfo => {
      if (userInfo) {
        return userInfo;
      } else {
        router.navigate(['/error'], {
          queryParams: { err: 500 }
        });
        return null;
      }
    })
    .catch(_e => {
      router.navigate(['/error'], { queryParams: { err: 500 } });
      return null;
    });
};
